<template>
  <el-dialog
    :center="true"
    :show-close="false"
    :title="$t('menu.sign-out')"
    :visible.sync="dialogVisible"
    class="confirm-dialog"
    width="320px"
  >
    <span>{{ $t('menu.confirm-sign-out') }}</span>
    <span
      slot="footer"
    >
      <el-row>
        <el-button
          class="primary-button"
          type="primary"
          @click="signOut"
        >
          {{ $t('yes') }}
        </el-button>
      </el-row>
      <el-row class="mt-20">
        <el-button
          class="primary-link"
          type="text"
          @click="dialogVisible = false"
        >
          {{ $t('no') }}
        </el-button>
      </el-row>
    </span>
  </el-dialog>
</template>

<script>
import { Auth } from '@aws-amplify/auth'

export default {
  name: 'SignOutDialog',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    dialogVisible: {
      get: function () {
        return this.visible;
      },
      set: function (value) {
        this.$emit('update:visible', value);
      },
    },
  },
  methods: {
    async signOut () {
      const currentAuth = await Auth.currentSession();
      const currentUser = await Auth.currentAuthenticatedUser();
      Auth.signOut().then(() => {
        if (window.messageHandler) {
          const message = {"type": "logout_completed", "token": currentAuth.getAccessToken().getJwtToken()};
          window.messageHandler.postMessage(JSON.stringify(message));
        }
        this.$axios.post('/api/v1/fe-status', {
          empUid: currentUser.attributes.sub,
          status: 200,
          message: 'Payment page event User logged out',
          timestamp: Date.now(),
        });
        this.$router.push({ name: 'SignIn' });
        this.$axios.post('/api/v1/fe-status', {
          empUid: currentUser.attributes.sub,
          status: 200,
          message: 'Payment page event User logged out',
          timestamp: Date.now(),
        });
      });
    },
  },
};
</script>

<style scoped>

</style>
